module.exports = __webpack_public_path__ + "static/v3Res1-413104585feb8d34b59ffa651726f450.png";